import { useBlockProps, RichText } from '@wordpress/block-editor';
import Style from './Style';

export default function save( { attributes } ) {
	const {
		mediaImage,
		altText,
		caption,
		imageObjectFit,
		enableImageCaption,
		captionAlignment,
		enableOverlay,
		overlayBackgroundColor,
		overlayText,
		overlayOpacity,
		enableText,
		blockId,
		onHoverImage,
		imageMaskShape,
	} = attributes;

	const blockProps = useBlockProps.save( {
		className: `alpha-image-blocks alpha-image-block-${ blockId } ${ onHoverImage } ${ imageMaskShape }`,
	} );
	const imageUrl = mediaImage?.url;

	return (
		<div { ...blockProps }>
			{ /* <Style attributes={attributes} /> */ }
			{ imageUrl && (
				<div style={ { position: 'relative' } }>
					{ enableOverlay && (
						<div
							className="overlay"
							style={ {
								backgroundColor: overlayBackgroundColor?.color,
								backgroundImage:
									overlayBackgroundColor?.gradient,
								position: 'absolute',
								width: '100%',
								height: '100%',
								zIndex: '99',
								opacity: overlayOpacity.desktop.val / 100,
								display: 'flex',
								alignItems: 'center',
							} }
						>
							{ enableText && (
								<RichText.Content
									tagName="p"
									value={ overlayText }
									className={ 'overlay-text' }
								/>
							) }
						</div>
					) }
					<img
						src={ imageUrl }
						alt={ altText }
						style={ { objectFit: imageObjectFit } }
					/>
				</div>
			) }
			{ enableImageCaption && caption && (
				<RichText.Content
					tagName="figcaption"
					value={ caption }
					style={ { textAlign: captionAlignment } }
				/>
			) }
		</div>
	);
}
